import React from 'react';
import {
    Card,
    CardHeader,
    Divider,
    Table,
    TableBody,
    makeStyles,
    Theme,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { ILeadInfo, TValue } from './types';
import { TextRow } from './TextRow';
import { CapitalizeNames } from 'src/utils/capitalize';

const useStyles = makeStyles((theme: Theme) => ({
    paper: {
        overflow: 'scroll',
    },
    margin: {
        marginBottom: '1em',
    },
}));

export const VehicleInfo = ({ lead, loading, ...props }: ILeadInfo) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const VALUES: TValue[] = [
        {
            header: t('Leads.Make'),
            text: CapitalizeNames(lead?.vehicle?.make?.name),
        },
        {
            header: t('Leads.Store'),
            text: lead?.store?.name,
        },
        {
            header: t('Leads.Model'),
            text: lead?.vehicle?.make?.name +
                ' ' +
                lead?.vehicle?.model +
                (lead?.version ? ' - ' + lead?.version.name : ''),
        },

        {
            header: t('Leads.Year'),
            text: CapitalizeNames(lead?.year),
        },
        {
            header: t('Leads.Type'),
            text: CapitalizeNames(lead?.vehicle?.modelType),
        },
        {
            header: t('Leads.CarType'),
            text: CapitalizeNames(lead?.carType),
        },
    ];

    return (
        <Card className={classes.paper} {...props}>
            <CardHeader title={t('Vehicles.Info')} />
            <Divider />
            <Table className={classes.margin}>
                <TableBody>
                    {VALUES.map((item, key) => (
                        <TextRow key={key} item={item} loading={loading} />
                    ))}
                </TableBody>
            </Table>
        </Card>
    );
};
